import client from "@irati/utils/services/apollo";
import locationFilterTagsQuery from "./queries/locationFilterTags";
var LocationFilterTagsService = /** @class */ (function () {
    function LocationFilterTagsService() {
    }
    LocationFilterTagsService.prototype.get = function () {
        return client.query({ query: locationFilterTagsQuery, fetchPolicy: "no-cache" }).then(function (_a) {
            var data = _a.data;
            return data.dealLocationFilterTags;
        });
    };
    return LocationFilterTagsService;
}());
var service = new LocationFilterTagsService();
export default service;
